import React from "react";
import heroImage from '../../template/images/hero_img.png'
import icon_1 from '../../template/images/icon_1.png'
import icon_2 from '../../template/images/icon_2.png'
import icon_3 from '../../template/images/icon_3.png'
import icon_4 from '../../template/images/icon_4.png'


const Banner = () => {

    const scrollToSection = () => {
    const section = document.getElementById('idOurCoursesMain');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

    return (
        <React.Fragment>
            <div className="hero_main">
                <div className="hero_inner">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <h3 className="hero_text"><span className="text_highlight"></span></h3>
                                <p className="hero_description">Finlabs Learning Hub aims at transforming the way individuals and organizations approach professional development and continuous learning.</p>
                                <p className="hero_description">This initiative is designed to empower learners with the skills and knowledge they need to thrive in an ever-evolving world.</p>
                                <p className="hero_description">By leveraging the Finlabs marketplace, we offer a comprehensive suite of on-demand learning solutions tailored to meet the needs of both individual learners and businesses. </p>
                                <div className="hero_button_main">
                                    <button className="hero_Explore_btn" onClick={scrollToSection}>Explore</button>
                                </div>
                            </div>
                           
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <img src={heroImage} className="hero_img img-fluid"></img>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hero_ftr">
                    <div className="container">
                        <div className="hero_ftr_inner">
                            <p className="hero_question">Who will Benefit? </p>
                            {/* <p className="hero_answer"><b>Individuals:</b> Professionals looking to upskill, get certified, and advance their careers. </p>
                            <p className="hero_msg"> <b>Organizations:</b> Companies seeking to enhance their workforce's skills and stay ahead of the competition.</p> */}

                            <div className="hero_icon_sec">
                            <div className="row">
                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
                                    <div className="icon_box">
                                        <img src={icon_1} className="hero_icon img-fluid"></img>
                                        <p className="icon_text">Finance Professionals</p>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
                                    <div className="icon_box">
                                        <img src={icon_2} className="hero_icon img-fluid"></img>
                                        <p className="icon_text">Growth-Oriented Individuals</p>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
                                    <div className="icon_box">
                                        <img src={icon_3} className="hero_icon img-fluid"></img>
                                        <p className="icon_text">Learning & Development Managers
</p>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
                                    <div className="icon_box">
                                        <img src={icon_4} className="hero_icon img-fluid"></img>
                                        <p className="icon_text">HR Professionals</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Banner;